<div [hidden]="!message" class="alert alert-{{type}}" role="alert" #alertNotice>
	<div class="alert-text" [innerHTML]="message"></div>
</div>

<div *ngIf="code=='10'"  [hidden]="!message" class="alert alert-danger" role="alert" >
	<div class="alert-text">
		<div>Para que sua confirmação seja reenviada  <a style="cursor: pointer;" (click)="resendConfirmation('teste')">clique aqui</a>
		</div>

	</div>
</div>